import { render, staticRenderFns } from "./TopicScreen.vue?vue&type=template&id=4ea0e090&"
import script from "./TopicScreen.vue?vue&type=script&lang=js&"
export * from "./TopicScreen.vue?vue&type=script&lang=js&"
import style0 from "./TopicScreen.vue?vue&type=style&index=0&id=4ea0e090&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports